import { render, staticRenderFns } from "./CustomerPermission.vue?vue&type=template&id=cfa56b1c&scoped=true&"
import script from "./CustomerPermission.vue?vue&type=script&lang=js&"
export * from "./CustomerPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa56b1c",
  null
  
)

export default component.exports